import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Inject, Input, OnInit, Output, output, SimpleChanges } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ArchivosSubidosService } from '../archivos-subidos/archivos-subidos.service';
import { UtilsService } from '../../utils-service';
import { DetalleTareaService } from '../../admin/detalle-tareas/detalle-tareas-service';
import { ComentariosService } from '../cometarios/comentarios.service';
import { ArchivosSubidosInterface } from 'app/models/archivos-subidos-model';
import { customDialogResponse, DialogDataInterface } from '../../GlobalComponents/confirm-dialog-with-notes/dialog-data.interface';
import { MatTooltipModule } from '@angular/material/tooltip';
import { environment as env } from 'environments/environments';
import { Tarea } from 'app/models/tareas.model';
import { ActualizarMetadataDTO } from 'app/models/actualizar-metadata.model';
import { forkJoin, Subject, takeUntil } from 'rxjs';


@Component({
    selector: 'vista-archivo',
    templateUrl: 'vista-archivo.html',
    imports:[CommonModule, MatButtonModule, MatIconModule, MatButtonToggleModule, MatTooltipModule]
})


export class VistaArchivoComponent implements OnInit {

    documentUrl: SafeResourceUrl | null = null;
    documentData:  ArchivosSubidosInterface;
    documentType: string  = 'application/pdf'
    mostrarVistaPrevia: boolean =  true
    renderObject = true;
    url2:string = '';
    tareaTipoGestion:number= env.TIPOLOGIA_ID_GESTIONES
    tipoTarea:number

    tareaDetalleModificada:Tarea
    estadoRechazado:number= 1
    estadoAceptado:number= 2

    //@Input() detalleTarea: Tarea
    @Input() archivo: ArchivosSubidosInterface;
    @Output() closeDrawer = new EventEmitter<void>();

    private destroy$ = new Subject<void>();
    
    constructor(
            private archivosSubidosService: ArchivosSubidosService,
            private utilsService: UtilsService,
            private _detalleTareasService: DetalleTareaService,
            private _comentariosService: ComentariosService,
            public dialog: MatDialog,  
    ) 
    { 
        
    }

    ngOnInit() {

        this._detalleTareasService.detalleTarea$
                .pipe(takeUntil(this.destroy$))
                .subscribe(tarea => {
                    this.tareaDetalleModificada = { ...tarea };
                    this.tipoTarea= tarea.tipoTarea.tipologiaId
                });
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['archivo'] && this.archivo) {
            this.documentType = this.getMime(this.archivo.tipoDocumento);
            this.documentUrl = this.archivo.blobURL ?? '';
            // recarga del object
            this.renderObject = false;
            setTimeout(() => {
                this.documentUrl = this.archivo.blobURL ?? '';
                this.renderObject = true;
            })

            this.documentData = this.archivo;
            this.mostrarVistaPrevia = this.utilsService.allowedExtensions(this.archivo.tipoDocumento);
        }
    }

    getMime(extension: string): string {
        const mimeTypes: { [key: string]: string } = {
            pdf: 'application/pdf',
            jpg: 'image/jpeg',
            jpeg: 'image/jpeg',
            png: 'image/png',
            bmp: 'image/bmp'
        };
    
        return mimeTypes[extension.toLowerCase()] || 'application/octet-stream';
    }
      
    openPDF(): void {
        window.open(this.documentData.pathDocumento, '_blank');
    }

    async downloadFile(): Promise<void> {
        try {

            const blob = this.tipoTarea === env.TIPOLOGIA_ID_GESTIONES
            ? await this.utilsService.getArchivosInternosBlob(this.documentData.archivoId)
            : await this.utilsService.getDocumentoBlob(this.documentData.archivoId);

            this.utilsService.downloadFile(blob, this.documentData.nombreArchivo, this.documentData.tipoDocumento);
        } catch (error) {
            console.error('Error al obtener el archivo:', error);
        }
    }

    aceptarDocumento(file: ArchivosSubidosInterface) {
        this.utilsService.open_confirm_dialog(`Esta seguro que desea Aceptar el documento  ${file.documentoEsperado ?? file.nombreArchivo}`, 'Confirmar Aceptación de Documento')
        .subscribe(response=>{
            if(response == 'confirmed'){
                const params = { 'aceptarArchivo' : true}
                
                //convertir funciones a observables
                const actualizarEstado$ = this.actualizarEstadoDocumento(file, params, 'archivo ok')  
                const actualizarMetadata$ = this.actualizarMetadata(file.archivoExternoId, this.estadoAceptado);
    
            // enviamos al API y actualizamos la lista de archivos y 
            // ejecutamos ambas operaciones en paralelo con forkJoin
            forkJoin([actualizarEstado$, actualizarMetadata$])
            }
        })

    }

    async actualizarMetadata(idDocumento: number, estado: number, comentario?: string) { 
            // Buscar el documento en el array de Documentos
            const documento = this.tareaDetalleModificada.metadata.Documentos.find(doc => doc.Id === idDocumento.toString());
        
            if (documento) {   
                documento.Estado = estado;
                documento.Comentario = comentario;
    
                const datosActualizados:ActualizarMetadataDTO = {
                    tarea: {
                        ...this.tareaDetalleModificada
                    }
                };
        
                try {
                    await this._detalleTareasService.putMetadata(datosActualizados, datosActualizados.tarea.tareaUuid);
                } catch (error) {
                   
                }
            }
        }


    async rechazarDocumento(file: ArchivosSubidosInterface) {
            // data para configurar el modal de confirmación
            const dialogConfig: DialogDataInterface = {
                title: 'Confirmar Rechazo de Documento 1',
                description: `Escriba los motivos de rechazo del documento: ${file.documentoEsperado ?? file.nombreArchivo}`,
                dimissible: false,
            };
        
            //se abre el modal y esperamos la respuesta del usuario en una promesa
            const dialogResponse: customDialogResponse = await this.utilsService.openConfirDialogWithNotes(dialogConfig);
        
            // validamos que la respuesta es true para rechazar el documento
            if (dialogResponse.confirmed) {
                const params = { aceptarArchivo: false };
        
                // Convertimos las funciones en Observables
                const actualizarEstado$ = this.actualizarEstadoDocumento(file, params, dialogResponse.comentarios);
                const actualizarMetadata$ = this.actualizarMetadata(file.archivoExternoId, this.estadoRechazado, dialogResponse.comentarios);
        
                // enviamos al API y actualizamos la lista de archivos y 
                // ejecutamos ambas operaciones en paralelo con forkJoin
                forkJoin([actualizarEstado$, actualizarMetadata$])
            }
        }
 
    private async actualizarEstadoDocumento(file:  ArchivosSubidosInterface, params:object, razon_rechazo?: string){
        await  this.archivosSubidosService.actualizarEstadoArchivo(file.archivoId, params, razon_rechazo)
            this.archivosSubidosService.getArchivosByEntity(this.utilsService.activeEntityUuid);
            this._detalleTareasService.getActividadesByTask(this.utilsService.activeEntityUuid)
            this._comentariosService.getComentariosByEntity(this.utilsService.activeEntityUuid)
    
        }
    
    closeDrawer1() {
        this.closeDrawer.emit();
    }
     
}



